<template>
  <div class="mk-contact">
    <div class="mk-contact__container">
       <button
        class="mk-contact__close"
        @click="closeCallback"
      >
        X
      </button>
      <span class="mk-contact__title">Create Offer with Shipping.</span>

      <div class="mk-contact__row">
        <div class="mk-contact__field">
          <label for="shippingPrice" class="mk-contact__label">Shipping Price</label>
          <span class="mk-contact__field__error">{{error.shippingPrice}}</span>
          <input
            @change="() => checkNotEmpty('library')"
            placeholder="Shipping Price"
            class="mk-contact__input"
            :class="error.shippingPrice ? 'mk-contact__input--error' : ''"
            id="shippingPrice"
            type="number"
            v-model="shippingPrice"
          />
          <span class="mk-contact__field__symbol">{{currencySymbol}}</span>
        </div>
      </div>
      <button
        class="mk-contact__send"
        @click="sendForm"
      >
      Create
      </button>
    </div>
  </div>
</template>

<script>
/**
 * Create Offer Popup
 * @author David <david.prenninger@gmx.de>
 *
 * This component shows a popup for the customer agent to choose
 * a specific shipping price and generate a PDF.
 */
import { generatePDF } from '../helpers/api';
import { PAGE_AREA, SERVER_ADDRESS } from '../constants';
import DownloadHelper from '../helpers/download';

export default {
  props: {
    closeCallback: Function,
    offerId: String,
  },
  data() {
    return {
      shippingPrice: [],
      error: {
        shippingPrice: '',
      },
      currencySymbol: '€',
      area: PAGE_AREA,
      items: [],
      totalPrice: 0,
    };
  },
  computed: {
    customerData() {
      return this.$store.getters.customerAgentData;
    },
    objectSections() {
      return this.$store.getters.objectSections;
    },
  },
  mounted() {
    switch (this.customerData.country) {
      case 'DE':
      case 'AT':
      case 'CH':
        this.area = 'DE';
        break;
      case 'US':
      case 'CA':
        this.area = 'US';
        break;
      case 'SE':
      case 'NO':
      case 'DK':
        this.area = 'DK';
        break;
      default:
        this.area = 'DE';
    }

    const items = {};
    let objects = [];
    this.objectSections.forEach((section) => {
      objects.push(
        section.connector,
        section.stand,
        section.glass,
        section.clamp1,
        section.clamp2,
      );
    });
    objects = objects.filter((element) => element !== undefined);

    objects.forEach((object) => {
      if (items[object.id]) {
        items[object.id].quantity += 1;
        items[object.id].total += object.price;
      } else {
        items[object.id] = { ...object, quantity: 1, total: object.price };
      }
    });

    Object.keys(items).forEach((itemId) => {
      this.items.push({
        ...items[itemId],
        total: Number(items[itemId].total).toFixed(2),
        price: Number(items[itemId].price).toFixed(2),
      });
      this.totalPrice += items[itemId].price * items[itemId].quantity;
    });

    this.totalPrice = Number(this.totalPrice).toFixed(2);

    this.items.sort((a, b) => {
      if (a.id < b.id) { return -1; }
      if (a.id > b.id) { return 1; }
      return 0;
    });

    switch (this.area) {
      case 'DE':
        this.currencySymbol = '€';
        break;
      case 'US':
        this.currencySymbol = '$';
        break;
      case 'DK':
        this.currencySymbol = 'DL';
        break;
      default:
        this.currencySymbol = '€';
        break;
    }
  },
  methods: {
    updateFiles() {
      this.files = this.$refs.fileInput.files;
      console.log(this.files);
    },
    sendForm() {
      Object.keys(this.error).forEach((key) => this.checkNotEmpty(key));
      if (Object.keys(this.error).some((error) => this.error[error] !== '')) {
        return;
      }

      generatePDF({
        list: this.items,
        totalPrice: this.totalPrice,
        totalNet: this.totalPrice,
        totalTax: 0,
        currencySymbol: this.currencySymbol,
        area: this.area,
        offerId: this.offerId,
        link: window.location.href,
        shippingPrice: Number(this.shippingPrice).toFixed(2),
        ...this.customerData,
      }).then((data) => {
        console.log(data);
        DownloadHelper.downloadURI(SERVER_ADDRESS + data.pdf);
      });
    },
    checkNotEmpty(key) {
      if (this[key] !== '') {
        this.error[key] = '';
        return;
      }
      this.error[key] = 'Field required';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-contact {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($c_primary, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;

  &__title {
    margin: 30px;
    font-size: 20px;
    font-weight: 500;
  }

  &__subtitle {
    color: $c_primary_lighter;
    margin: 10px 0;
  }

  &__row {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
  }

  &__field {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 5px 5px;
    width: 100%;
    max-width: 250px;

    &__symbol {
      font-size: 20px;
      margin-left: 10px;
    }

    &__error {
      font-size: 12px;
      color: $c_accent;
    }
  }

  &__label {
    display: none;
  }

  &__input {
    box-sizing: border-box;
    padding: 10px 20px;
    border: 1px solid $c_primary_light;

    &:focus {
      border: 1px solid $c_primary_lighter;
    }

    &--error {
      border: 1px solid $c_accent;
    }
  }

  &__send {
    margin-top: 10px;
    width: 50%;
    align-self: center;
    background-color: $c_accent;
    box-shadow: $bs_md;
    padding: 10px 20px;
    border: none;
    border-radius: $br_md;
    color: $c_white;
    text-transform: uppercase;
  }

  &__close {
    background-color: $c_white;
    box-shadow: $bs_md;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    right: 10px;
    border: none;
  }

  &__message {
    margin: 5px 5px;
    box-sizing: border-box;
    padding: 10px 20px;
    border: 1px solid $c_primary_light;

    &__label {
      align-self: flex-start;
      margin: 5px 5px;
      color: $c_primary_lighter;
    }
  }

  &__container {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 10px;
    border-radius: $br_md;
    box-shadow: $bs_md;
    background-color: $c_white;
  }

  &__select {
    width: 100%;
    flex-grow: 1;
    box-sizing: border-box;
    padding: 10px 20px;
    border: 1px solid $c_primary_light;

    &__error {
      border: 1px solid $c_accent;
    }
  }
}
</style>
